import styles from './style.module.css';
import {useEffect, useState} from 'react';
import {useRouter} from 'next/router';
import {useRequest} from '@hooks/use-request';
import {getRequireRegistrationUIDS} from '@lib/utils';
import {ContentContainer} from '@interfaces/content-container';
import {LocaleEnum} from '@enums/locale';
import RequiresRegistrationOverlay from '@components/ReuiresRegistrationOverlay';

export function ProductTabPane({
  isActive,
  tab,
}: {
  isActive: boolean;
  tab: ContentContainer;
  productGroupUID: string;
}) {
  const router = useRouter();
  const locale = router.locale as LocaleEnum;
  const {sendRequest, loading} = useRequest(locale);
  const [isPageRegistered, setIsPageRegistered] = useState(false);

  const checkProductGroupTab = () => {
    const {uuid} = router.query;
    sendRequest({
      url: `/pages/${tab.id}/checkregistration`,
      method: 'post',
      headers: {
        'X-Requires-Registration-Uuids':
          getRequireRegistrationUIDS() + (uuid ? `,${uuid}` : ''),
      },
      onSuccess: () => {
        setIsPageRegistered(true);
      },
      onError: errors => {
        console.log(errors);
      },
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && tab.requires_registration === 1) {
      checkProductGroupTab();
    }
  }, [router.query.uuid]);
  return (
    <div
      className={`${styles.productTabPane} ${isActive && styles.isActive} row`}
      style={{
        pointerEvents:
          isPageRegistered ||
          !tab.requires_registration ||
          tab.requires_registration === 0
            ? 'initial'
            : 'none',
      }}
    >
      {!isPageRegistered && tab.requires_registration === 1 && (
        <RequiresRegistrationOverlay
          pageUrl={`${router.asPath.split('?')[0]}?tab=${tab.id}`}
          identifier={tab.id}
          verifying={loading}
        />
      )}
      {tab.contents.map((content, index) => {
        const col_1 = content[`column_div_1_${locale}`];
        const col_2 = content[`column_div_2_${locale}`];
        const col_3 = content[`column_div_3_${locale}`];
        return (
          <div className={'row'} key={index}>
            {col_1 ? (
              <div
                className={'col'}
                dangerouslySetInnerHTML={{__html: col_1}}
              ></div>
            ) : null}
            {col_2 ? (
              <div
                className={'col'}
                dangerouslySetInnerHTML={{__html: col_2}}
              ></div>
            ) : null}
            {col_3 ? (
              <div
                className={'col'}
                dangerouslySetInnerHTML={{__html: col_3}}
              ></div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
